import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { GeckoFileCategory, RolodexEntryType } from 'types'

export const useAssetImageData = (unitID: string | undefined) => {
  const {
    reports: assetThumbnails,
    isLoading,
    forceRefresh: refreshThumbnails,
  } = useRolodexEntries(
    !unitID
      ? undefined
      : {
          type: [RolodexEntryType.REPORT],
          tags: { unit: unitID },
          filters: [
            {
              key: 'file_category',
              op: '=',
              value: GeckoFileCategory.IMAGE,
              cast: 'string',
            },
          ],
        }
  )

  return useMemo(() => {
    return {
      assetThumbnails,
      isLoading,
      refreshThumbnails,
    }
  }, [assetThumbnails, isLoading, refreshThumbnails])
}
